import React from 'react';
import useDocumentMeta from './useDocumentMeta';

function Blog() {
    useDocumentMeta({
        title: 'Blog | Yay Fun, Inc.',
        description: 'Notes from Yay Fun, Inc., an Austin software product studio.',
        path: '/blog',
        noindex: true,
    });

    return (
        <section className="page">
            <div className="container page__head">
                <p className="kicker">Blog</p>
                <h1 className="page__title">Blog</h1>
                <p className="page__lede">Current topic discussion covering the retail, finance, and game industry.</p>
            </div>
        </section>
    )
}

export default Blog
